import create from 'zustand';
import { UpdateNotesQueryState } from './interfaces/UpdateQueryState';
import { createCommonNotesQuerySlice } from './slices/NotesQuerySlices/CommonNotesQuerySlice';
import { createUpdateNotesQuerySlice } from './slices/NotesQuerySlices/UpdateNotesQuerySlice';

export const useUpdateNotesQueryStore = create<UpdateNotesQueryState>((set) => ({
  ...createCommonNotesQuerySlice(set),
  ...createUpdateNotesQuerySlice(set)
}));
